import * as React from 'react';
import { ArrowDown } from '../../icons/arrows/ArrowDown';
import { ArrowUp } from '../../icons/arrows/ArrowUp';

export interface IProps {
  value: number;
  className?: string;
}

export function PosNegArrow({ value, className }: IProps) {
  return (
    <>
      {value !== null && value > 0 && <ArrowUp className={className} />}
      {value !== null && value < 0 && <ArrowDown className={className} />}
    </>
  );
}
